import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminGroupsLabsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/groups_labs',
  validateSearch: z.object({
    labId: z.number().optional(),
    groupId: z.number().optional(),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/admin/GroupsLabs/AdminGroupsLabsPage/AdminGroupsLabsPage').then((d) => d.Route)
);
